import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
export var setActionAndRedirect = () => {
  if (!window.location.href.includes("utente")) return;
  //We are in a private page...
  //The action value indicates whether the login modal shall be shown or not
  window.location.href = "".concat(window.location.origin, "?action=login");
  //Saving the current location so we can enter it when the user successfully logs in
  localStorage.setItem("redirect", window.location.href);
};